import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/api.service';
import { Panel } from 'src/app/model/panel-modal/panel-model';
import { CandidateListModalComponent } from './candidate-list-modal/candidate-list-modal.component';
import { CreatePanelComponent } from './create-panel/create-panel.component';
import { ProcessService } from 'src/app/shared/process-service/process.service';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { AutoPanelCreationComponent } from './auto-panel-creation/auto-panel-creation.component';
import { Process } from 'src/app/model/process-model/process.model';
import { NotificationService } from 'src/app/shared/notification.service';
import { Router } from '@angular/router';
import { DialogService } from 'src/app/shared/dialog-service/dialog.service';
import { DatePipe, formatDate } from '@angular/common';
import { PanelMemberListModalComponent } from './panel-member-list-modal/panel-member-list-modal.component';
import { Candidate } from 'src/app/model/candidate.model';
import { AssignedPanelDetsilsComponent } from './assigned-panel-detsils/assigned-panel-detsils.component';
import { AddMoreCandidateModelComponent } from './addMoreCandidateModel/add-more-candidate-model/add-more-candidate-model.component';
import { IMMEventService } from 'src/app/shared/immEevent-service/imm-event.service';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import {CdkStepper} from '@angular/cdk/stepper';


export interface DialogData {
  noOfPanels: number;
  panelName: string;
  roomIdentification: string;
  // panelMembers: [];
  // candidates: [];
}

@Component({
  selector: 'app-processes',
  templateUrl: './processes.component.html',
  styleUrls: ['./processes.component.scss'],
})

export class ProcessesComponent implements OnInit {
  DialogRefCreatePanelComponent: MatDialogRef<CreatePanelComponent>;
  panelName: string;
  roomIdentification: string;
  panelMembers: [];
  candidates: [];
  process = "";
  cards = [];
  // isLinear = false;
  formGroup : FormGroup;
  form: FormArray;
  minDate: Date;

  // panelMemberId: number;
  eventStartDate: any;
  processes: Process[];
  processIndexMap = new Map();
  sortListedCandidates = [];
  selectedCandidates = 0;
  rejectedCandidates = 0;

  numberOfPanel = [];
  noOfPanels: number;
  candidateList = [];
  panelMemberList = [];

  allPanels: Panel[];
  panels = [];
  panelId: string;
  // panelDetails: Panel[];
  totalAssignedPerProcess = 0;
  totalShortListedCandidate: number;
  panelIndexMap = new Map();

  selectedCandidatePerPanel: any;
  selectedPanelMemberPerPanel: any;
  selectedCandidate = [];
  selectedPanelMember = [];
  selected = new FormControl(0);

  panelButton = "Create Room";
  onEditPanelId = 0;

  processButton = "Create Process";
  onEditProcesslId = 0;
  onEditProcessSeq: number;

  shortListedMap = new Map();
  allCandidate: any;

  panelNotYetStartedMap = new Map();
  panelInProcessMap = new Map();
  panelCompletedMap = new Map();

  autoPanelShowHide = false;

  panelLengthArray = []

  datePipe = new DatePipe("en-US");

  public errorMsg;
  // public eventDateValidator = true;
  // public invalidDate = false;

  private eventId = this.apiService.getEventId();

  constructor(
    private router: Router,
    public processService: ProcessService,
    public panelService: PanelService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private eventService: IMMEventService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
  ) {
    // const currentYear = new Date().getFullYear();
    this.minDate = new Date();
   }

  currentProcessTab: number;
  selectedIndex: number;

  ngOnInit() {
    // setTimeout("location.reload(true);", 200000);
    this.getEvent();
    this.getAllProcess();

    this.currentProcessTab = this.activatedRoute.snapshot.queryParams.processIndex;
  }

  getEvent() {
    this.eventService.findById(this.eventId).then(
      res => {
        let eventDate = res.startDate;
        const date = new Date(eventDate);
        // this.eventStartDate = moment();
        this.eventStartDate = moment.utc().local().format('YYYY-MM-DD HH:mm:ss a');
        // console.log(this.eventStartDate);
        const eventStartDateValue = this.eventStartDate && this.eventStartDate.value;
        const formProcessStartDateValue = this.processService.form &&
                                          this.processService.form.value.startDate &&
                                          this.processService.form.value.startDate.value;
        if(eventStartDateValue && formProcessStartDateValue && (eventStartDateValue > formProcessStartDateValue)) {
          // return this.eventDateValidator = true;
          setTimeout(function() {
            this.eventDateValidator = false;
            console.log(this.eventDateValidator);
          }.bind(this), 3000);
        }
      }
    )
  }

  getAllPanel(processId) {
    this.autoPanelShowHide = true;
    this.panelService.findAll(processId).then(
      allPanels => {
        this.allPanels = allPanels;
        if (allPanels != null) {
          for (let i = 0; i < allPanels.length; i++) {
            this.autoPanelShowHide = false;
            this.numberOfPanel.push(allPanels[i].panelId);
            this.totalSelectedRejected(allPanels[i].panelCandidates);
            this.totalAssignedPerProcess = this.totalAssignedPerProcess + allPanels[i].assignedCnt;
            if (allPanels[i].assignedCnt === allPanels[i].selectedCnt + allPanels[i].rejectedCnt) {
              this.panelCompletedMap.set(allPanels[i].panelId, true);
            } else if (allPanels[i].selectedCnt === 0 && allPanels[i].rejectedCnt === 0) {
              this.panelNotYetStartedMap.set(allPanels[i].panelId, true);
            } else if (allPanels[i].selectedCnt > 0 || allPanels[i].rejectedCnt > 0) {
              this.panelInProcessMap.set(allPanels[i].panelId, true);
            }
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getShortlistedCandidates(processId) {
    this.processService.findAllShortlistedCandidates(processId).then(
      candidates => {
        this.allCandidate = candidates;
        this.shortListedMap.set(processId, candidates.length);
      },
      err => {
        console.log(err);
      }
    );
  }
  totalSelectedRejected(allPanelCandidate: Candidate[]) {
    for (let i = 0; i < allPanelCandidate.length; i++) {
      if (allPanelCandidate[i].status == 2) {
        this.selectedCandidates = this.selectedCandidates + 1;
      } else if (allPanelCandidate[i].status == 3) {
        this.rejectedCandidates = this.rejectedCandidates + 1;
      }
    }
  }
  getAllProcess() {
    this.processService.findAll().then(
      processes => {
        this.processes = processes;
        if (processes != null) {
          for (let i = 0; i < processes.length; i++) {
            this.processIndexMap.set(i, processes[i].processId);
            this.getShortlistedCandidates(processes[i].processId);
          }
          this.selectedIndex = this.currentProcessTab;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  addProcessTab() {
    if (this.processService.form.valid) {
      if (this.processButton === "Update Process") {
        let processName = this.processService.form.value.processName;
        let startDate = this.processService.form.value.startDate;
        startDate = this.datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm');
        let endDate = this.processService.form.value.endDate;
        endDate = this.datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm');
        let process = new Process(processName, startDate, endDate, this.onEditProcessSeq);
        this.processService.updateProcess(process, this.onEditProcesslId).then(
          processes => {

            this.getEvent();
            this.getAllProcess();
            this.notificationService.success('Process updated successfully');
          },
          err => {
            console.error(err);
            this.notificationService.warn("Unable to update the process, " + err);
            return false;
          }
        );
      }
      else {
        let processName = this.processService.form.value.processName;
        let startDate = this.processService.form.value.startDate;
        startDate = this.datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm');
        let endDate = this.processService.form.value.endDate;
        endDate = this.datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm');
        if (processName === '' || processName === null || startDate === null || endDate === null) {
          this.notificationService.warn("Please fill all the fields");
        }
        else {
          let processSeq = 1;
        if (this.processes != null) {
          processSeq = this.processes[this.processes.length - 1].processSeq + 1;
        }
        let process = new Process(processName, startDate, endDate, processSeq);
        this.processService.createProcess(process).then(
          processes => {
            if (this.processes != null) {
              this.processes.push(processes[0]);
            } else {
              this.processes = processes;
            }
            this.processIndexMap.set(this.processes.length - 1, processes[0].processId);
            this.getShortlistedCandidates(processes[0].processId);
          },
          err => {
            // console.log(err);
            try {
              const { message } = JSON.parse(err);
              this.notificationService.warn(
                message.toLowerCase().includes('sql')
                ? 'Unable to create Process'
                : 'Unable to create Process'
              )
            } catch (error) {
              const errMessage = typeof err === 'string' ? err : 'Unable to create Process';
              this.notificationService.warn(errMessage);
              console.error(error);
            }
            return false;
          }
        );
        this.notificationService.success('Process created successfully');
        }
      }
      this.processFormReset();
    }
  }
  processFormReset() {
    this.onEditProcesslId = 0;
    this.processButton = "Create Process";
    this.processService.form.reset();
    this.processService.form.controls.processName.setErrors(null);
    this.processService.form.controls.startDate.setErrors(null);
    this.processService.form.controls.endDate.setErrors(null);
  }
  onClear() {
    this.onEditProcesslId = 0;
    this.processButton = "Create Process";
    this.processService.form.reset();
    this.notificationService.success('Cleared');
  }

  removeProcessTab(processId) {
    this.dialogService.openConfirmDialog('Are you sure to delete this record ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.processService.deleteProcess(processId);
          for (let i = 0; i <= this.processes.length; i++) {
            if (this.processes[i].processId == processId) {
              this.processes.splice(i);
            }
          }
          this.notificationService.success('! Deleted successfully');
        }
      });
  }

  onEditProcess(processId) {
    this.processButton = "Update Process"
    for (let process of this.processes) {
      if (process['processId'] == processId) {
        this.onEditProcesslId = processId;
        this.processService.form.controls['id'].setValue(process['processId']);
        this.processService.form.controls['processName'].setValue(process['processName']);
        this.processService.form.controls['startDate'].setValue(new Date(process['startDate']));
        this.processService.form.controls['endDate'].setValue(new Date(process['endDate']));
        this.processService.form.controls['processSeq'].setValue(process['processSeq']);
        this.onEditProcessSeq = process['processSeq'];
      }
    }
  }

  removePanel(panelId) {
    this.dialogService.openConfirmDialog('Are you sure to delete this record ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.panelService.deletePanel(panelId)
            .then(data => {
              this.notificationService.success('Deleted successfully');
              this.allPanels = data;
            })
            .catch(err => {
              const errorMessage = err && err.errorMessage;
              this.notificationService.warn(errorMessage || 'Deletion Failed');
            });
          // for (let i = 0; i <= this.allPanels.length; i++) {
          //   if (this.allPanels[i].panelId == panelId) {
          //     this.allPanels.splice(i);
          //   }
          // }
        }
      });
  }

  onSubmitPanelCreation(processId) {
    if (this.panelService.form.valid) {
      if (this.panelButton === "Update Room") {
        let panelName = this.panelService.form.value.panelName;
        let roomIdentification = this.panelService.form.value.roomIdentification;
        let panelMembers = this.selectedPanelMember;
        let candidates = this.selectedCandidate;
        let panel = new Panel(panelName, roomIdentification, panelMembers, candidates);               //panelMembers, candidates
        this.panelService.updatePanel(panel, this.onEditPanelId).then(
          updatePanels => {
            this.tabClick(updatePanels.processId);
          },
          err => {
            console.log(err);
            this.notificationService.warn("Unable to update the panel, " + err);
            return false;
          }
        );
        this.notificationService.success('Panel Successfully updated');
      }
      else {
        let panelName = this.panelService.form.value.panelName;
        let roomIdentification = this.panelService.form.value.roomIdentification;
        let panelMembers = this.selectedPanelMember;
        let candidates = this.selectedCandidate;
        let panel = new Panel(panelName, roomIdentification, panelMembers, candidates);                 //panelMembers, candidates
        this.panelService.createPanel(panel, processId).then(
          createPanel => {
            this.tabClick(processId);
          },
          err => {
            console.log(err);
            this.notificationService.warn("Unable to create the panel, " + err);
            return false;
          }
        );
        this.notificationService.success('Panel Successfully created');
      }
      this.panelFormReset();
    }
  }
  panelFormReset() {
    this.onEditPanelId = 0;
    this.panelButton = "Create Room";
    this.panelService.form.reset();
    this.panelService.form.controls.panelName.setErrors(null);
    this.panelService.form.controls.roomIdentification.setErrors(null);
    // this.panelService.form.controls.panelMembers.setErrors(null);
    // this.panelService.form.controls.candidates.setErrors(null);
  }
  clearPanelForm() {
    this.onEditPanelId = 0;
    this.panelButton = "Create Room";
    this.panelService.form.reset();
    this.notificationService.success(' Cleared');
  }

  onEditPanel(processId, panelId) {
    this.panelButton = "Update Room";
    this.onEditPanelId = panelId;
    
    this.DialogRefCreatePanelComponent = this.dialog.open(CreatePanelComponent, {
      width: '40%',
      disableClose: true,
      autoFocus: true,
      data: {
        processId: processId,
        panelId: panelId,
        panelName: this.panelName,
        roomIdentification: this.roomIdentification,
        panelButton: this.panelButton,
        onEditPanelId: this.onEditPanelId,
        selectedCandidate: this. selectedCandidate,
        selectedPanelMember: this.selectedPanelMember
      }       // panelMembers: this.panelMembers, candidates: this.candidates, 
      // data: { panelName: this.panelName }
    });

    const subscribeRef = this.DialogRefCreatePanelComponent
                          .componentInstance
                          .fetchPanels
                          .subscribe(updatedProcessId => {
                              this.tabClick(updatedProcessId)
                          })
    this.DialogRefCreatePanelComponent
        .afterClosed()
        .subscribe(result => {
          subscribeRef.unsubscribe();
          // this.getAllPanel(processId);
        });

    for (let panel of this.allPanels) {
    
      if (panel['panelId'] == panelId) {
        this.panelService.form.controls['id'].setValue(panel['panelId']);
        this.panelService.form.controls['panelName'].setValue(panel['panelName']);
        this.panelService.form.controls['roomIdentification'].setValue(panel['roomNo']);
        this.panelService.form.controls['meetingLink'].setValue(panel['meetingLink']);
        this.panelService.form.controls['panelMembers'].setValue(this.onEditPanelReturnPanelMember(panel['panelPanelMembers']));
        this.panelService.form.controls['candidates'].setValue(this.onEditPanelReturnCandidate(panel['panelCandidates']));

        // console.log("-----Inside onEditPanel() Panel Members-------", this.selectedPanelMember);
        // console.log("-----Inside onEditPanel() Candidates-------", this.selectedCandidate);
        this.panelService.sendPanelValues(this.selectedPanelMember)
        this.panelService.sendCandidatesValue(this.selectedCandidate);

      }
    }

  }

  // onEditPanel(panelId) {
  //   this.panelButton = "Update Room"; 
  //   for (let panel of this.allPanels) {
  //     if (panel['panelId'] == panelId) {
  //       this.onEditPanelId = panelId;
  //       this.panelService.form.controls['id'].setValue(panel['panelId']);
  //       this.panelService.form.controls['panelName'].setValue(panel['panelName']);
  //       this.panelService.form.controls['roomIdentification'].setValue(panel['roomNo']);
  //       this.panelService.form.controls['panelMembers'].setValue(this.onEditPanelReturnPanelMember(panel['panelPanelMembers']));
  //       this.panelService.form.controls['candidates'].setValue(this.onEditPanelReturnCandidate(panel['panelCandidates']));
  //     }
  //   }
  // }

  onEditPanelReturnPanelMember(arrayName: any) {
    this.selectedPanelMember = [];
    let name = "";
    for (let i = 0; i < arrayName.length; i++) {
      name = name + arrayName[i].panelMemberName + ", ";
      this.selectedPanelMember.push(arrayName[i].panelMemberId);
    }
    name = name.substring(0, name.length-2);
    return name;
  }
  onEditPanelReturnCandidate(arrayName: any) {
    this.selectedCandidate = [];

    let name = "";
    for (let i = 0; i < arrayName.length; i++) {
      name = name + arrayName[i].candidateName + ", ";
      this.selectedCandidate.push(arrayName[i].candidateId);
    }
    name = name.substring(0, name.length-2);
    return name;
  }

  panelAssign(panelId) {
    this.panelService.panelAssigning(panelId).then(
      processes => {
        this.notificationService.success('Successfully sent email to candidates and panel members');
      },
      err => {
        this.notificationService.warn('Mail did not sent successfully, Try again later');
        console.log(err);
      }
    );
    // window.location.reload();
  }

  eventTabClick($event) {
    let processId = this.processIndexMap.get($event.index);
    if (processId) {
      this.router.navigate(['processes'], {queryParams : {processIndex: $event.index}});
    }
    this.tabClick(processId);
  }

  tabClick(processId) {
    this.autoPanelShowHide = true;
    this.selectedCandidates = 0;
    this.rejectedCandidates = 0;
    this.totalAssignedPerProcess = 0;
    this.numberOfPanel = [];
    this.panelService.findAll(processId).then(
      allPanels => {
        this.panelLengthArray = allPanels;
        this.allPanels = allPanels;
        if (allPanels != null) {
          for (let i = 0; i < allPanels.length; i++) {
            this.autoPanelShowHide = false;
            this.numberOfPanel.push(allPanels[i].panelId);
            this.totalSelectedRejected(allPanels[i].panelCandidates);
            this.totalAssignedPerProcess = this.totalAssignedPerProcess + allPanels[i].assignedCnt;
            if (allPanels[i].assignedCnt === allPanels[i].selectedCnt + allPanels[i].rejectedCnt) {
              this.panelCompletedMap.set(allPanels[i].panelId, true);
            } else if (allPanels[i].selectedCnt === 0 && allPanels[i].rejectedCnt === 0) {
              this.panelNotYetStartedMap.set(allPanels[i].panelId, true);
            } else if (allPanels[i].selectedCnt > 0 || allPanels[i].rejectedCnt > 0) {
              this.panelInProcessMap.set(allPanels[i].panelId, true);
            }
          }
        }
      },
      err => {
        console.log(err);
      }
    );
    this.processFormReset();
    this.panelFormReset();
  }

  addMoreCandidate(panelId, processId) {
    const dialogRef = this.dialog.open(AddMoreCandidateModelComponent, {
      width: '60%',
      disableClose: true,
      autoFocus: true,
      data: { processId: processId, panelId: panelId }
    });
    const subscribeRef = dialogRef
                        .componentInstance
                        .updatePanelList
                        .subscribe(data => {
                          this.tabClick(processId);
                          // this.getAllPanel(processId);
                        });

    dialogRef.afterClosed().subscribe(result => {
    // console.log('Dialog was closed');
    subscribeRef.unsubscribe();
    // this.getAllPanel(processId);
    // this.getEvent();
    // this.getAllProcess();
    });
  }

  panelMemberListModal(panelId, processId) {
    this.selectedPanelMember = [];
    this.onEditPanelId = 0;
    const dialogRef = this.dialog.open(PanelMemberListModalComponent, {
      width: '60%',
      disableClose: true,
      autoFocus: true,
      data: { selectedPanelMemberPerPanel: this.selectedPanelMemberPerPanel, processId: processId, panelId: panelId, onEditPanel: this.onEditPanelId }
    });

    dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
         let allPanelMember = "";
    if (typeof result !== "undefined") {
          this.selectedPanelMemberPerPanel = result;
          for (let row of result.selectedPanelMemberPerPanel[0]) {
            allPanelMember = allPanelMember + row.panelMemberName + ", ";
            this.selectedPanelMember.push(row.panelMemberId);
          }
          this.panelService.form.controls['panelMembers'].setValue(allPanelMember);
        }
      });
  }

  // panelMemberListModal(processId) {
  //   this.selectedPanelMember = [];
  //   const dialogRef = this.dialog.open(PanelMemberListModalComponent, {
  //     width: '60%',
  //     disableClose: true,
  //     autoFocus: true,
  //     data: { selectedPanelMemberPerPanel: this.selectedPanelMemberPerPanel, processId: processId, onEditPanel: this.onEditPanelId }
  //   });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
    //   let allPanelMember = "";
    //   if (typeof result !== "undefined") {
    //     this.selectedPanelMemberPerPanel = result;
    //     for (let row of result.selectedPanelMemberPerPanel[0]) {
    //       allPanelMember = allPanelMember + row.panelMemberName + ", ";
    //       this.selectedPanelMember.push(row.panelMemberId);
    //     }
    //     this.panelService.form.controls['panelMembers'].setValue(allPanelMember);
    //   }
    // });
  // }

  candidateListModal(processId) {
    const dialogRef = this.dialog.open(CandidateListModalComponent, {
      width: '80%',
      disableClose: true,
      autoFocus: true,
      data: { selectedCandidatePerPanel: this.selectedCandidatePerPanel, processId: processId, onEditPanel: this.onEditPanelId }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedCandidate = [];
      console.log('The dialog was closed');
      let allCandidate = "";
      if (typeof result !== "undefined") {
        this.selectedCandidatePerPanel = result;
        for (let row of result.selectedCandidatePerPanel[0]) {
          allCandidate = allCandidate + row.candidateName + ", ";
          this.selectedCandidate.push(row.candidateId);
        }
        this.panelService.form.controls['candidates'].setValue(allCandidate);
      }
    });
  }

  openAssignedCandidates(panelId) {
    const dialogRef = this.dialog.open(AssignedPanelDetsilsComponent, {
      width: '70%',
      disableClose: true,
      autoFocus: true,
      data: { panelId: panelId }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  //Auto Panel Creeation Modal Functions
  onAutoPanelCreation(processId) {   
    const dialogRef = this.dialog.open(AutoPanelCreationComponent, {
      width: '50%',
      disableClose: true,
      autoFocus: true,
      data: { processId: processId }
    });

    const subscribeRef = dialogRef
                        .componentInstance
                        .autoPanelCreator
                        .subscribe();
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      subscribeRef.unsubscribe();
      // this.getAllPanel(processId);
    });
  }
   onPanelCreate(processId) {
    //  this.panelButton = "Create Room";
    this.DialogRefCreatePanelComponent =  this.dialog.open(CreatePanelComponent, {
      width: '40%',
      disableClose: true,
      autoFocus: true,
      data: {processId: processId, panelName: this.panelName, roomIdentification: this.roomIdentification}
      // data: { panelName: this.panelName }
    });

    const subscribeRef = this.DialogRefCreatePanelComponent
                          .componentInstance
                          .fetchPanels
                          .subscribe(result => {
                            this.tabClick(processId);
                          });

    this.DialogRefCreatePanelComponent.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
      subscribeRef.unsubscribe();
      // this.getAllPanel(processId);
      // this.panelName = result;
      // this.roomIdentification = result;
    });

    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    // dialogConfig.autoFocus = true;
    // dialogConfig.width = "40%";
    // this.dialog.open(CreatePanelComponent, dialogConfig);
  }
  compareCategoryObjects(object1: any, object2: any) {
    return object1 && object2 && object1.panelMemberId == object2.panelMemberId;
  }

  getToolTipData(processId) {
    return "";
  }
}
